<template>
    <div class="ui-card-broker">
        <ui-overlay-load v-if="load" />

        <div v-else>
            <div v-if="!broker" class="ui-no-content">
                <div class="title">É necessário selecionar um cliente.</div>
            </div>

            <div v-else class="ui-card">
                <div class="ui-card-content">
                    <ui-image
                        v-if="coverComputed"
                        :src="getImgCDN(coverComputed)"
                        :alt="nameComputed"
                        design="circle"
                        w="60"
                        h="60" />

                    <ui-badge v-else :initials="nameComputed" color="#606d84" design="lg" :radius="60" />

                    <div>
                        <div v-if="nameComputed" class="broker-name">{{ nameComputed }}</div>
                        <div v-if="teamComputed" class="broker-role">{{ teamComputed }}</div>
                        <ui-tag-line
                            v-if="roleComputed"
                            :background="statusComputed"
                            :text="roleComputed"
                            :text-size="11"
                            color="#fff" />
                    </div>
                </div>

                <div class="ui-card-footer">
                    <ui-tag-icon
                        v-if="phoneComputed"
                        :icon-size="16"
                        :text-size="11"
                        :border="0"
                        :text="String(phoneComputed)"
                        icon="fab fa-whatsapp" />

                    <ui-tag-icon
                        v-if="emailComputed"
                        :icon-size="16"
                        :text-size="11"
                        :border="0"
                        :text="emailComputed"
                        icon="fal fa-envelope-open-text" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { uiOverlayLoad, uiImage, uiBadge } from '@/components/ui'
    import { uiTagLine, uiTagIcon } from '@/components/ui/tags'
    import helpers from '@/mixins/helpers'

    export default {
        components: {
            uiOverlayLoad,
            uiImage,
            uiBadge,
            uiTagLine,
            uiTagIcon,
        },

        mixins: [helpers],

        props: {
            /**
             * Dados referentes ao corretor
             */
            broker: {
                type: Object,
                required: false,
                default () {
                    return {}
                }
            },
            /**
             * Usado para mostrar o load do componente
             */
            load: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        computed: {
            /**
             * Verifica se o negócio possui corretor, gerente ou somente o owner para ser o responsável pela simulação
             */
            ownerComputed() {
                if (this.broker.broker) {
                    return this.broker.broker.user

                } else if (this.broker.manager) {
                    return this.broker.manager.user

                } else {
                    return this.broker.owner
                }
            },

            phoneComputed() {
                return this.maskPhone(this.ownerComputed.phone) || this.maskPhone(this.ownerComputed.mobile)
            },

            nameComputed() {
                return this.ownerComputed.first_name ? this.ownerComputed.first_name : null
            },

            emailComputed() {
                return this.ownerComputed.email ? this.ownerComputed.email : null
            },

            coverComputed() {
                return this.ownerComputed.cover ? this.ownerComputed.cover : null
            },

            teamComputed() {
                return this.broker.team ? this.broker.team.name : null
            },

            roleComputed() {
                let role = ''
                switch (this.ownerComputed.user_group) {
                    case 'admin':
                        role = 'Administrador'
                        break

                    case 'manager':
                        role = 'Gerente'
                        break

                    case 'supervisor':
                        role = 'Supervisor'
                        break

                    case 'broker':
                        role = 'Corretor'
                        break
                    
                    case 'collaborator':
                        role = 'Colaborador'
                        break
                }

                return role
            },

            statusComputed() {
                if (this.ownerComputed.status == 'active') {
                    return '#1bca85'

                } else {
                    return '#ff9744'
                }
            },
        },

        methods: {
            maskPhone(value) {
                if (!value) return ''

                let str = value.replace(/\D/g, "").replace(/^0/, "")

                if (str.length > 10) {
                    return str.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3")

                } else if (str.length > 5) {
                    return str.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3")

                } else if (str.length > 2) {
                    return str.replace(/^(\d\d)(\d{0,5})/, "$1-$2")

                } else {
                    return str.replace(/^(\d*)/, "($1")
                }
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>